import React, { useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents
} from "react-leaflet";
import L from "leaflet";

// Default marker fix (optional for proper icons)
import "leaflet/dist/leaflet.css";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png"
});

// Component to handle click and add marker
function ClickToAddMarker({ setMarkers }) {
  useMapEvents({
    click(e) {
      setMarkers((prev) => [...prev, e.latlng]);
    }
  });
  return null;
}

const PhilippinesMap = () => {
  const [markers, setMarkers] = useState([]);

  return (
    <MapContainer
      center={[12.8797, 121.7740]} // Center of the Philippines
      zoom={6}
      minZoom={5}
      maxZoom={10}
      style={{ height: "750px", width: "100%" }}
      scrollWheelZoom={true}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
      />

      <ClickToAddMarker setMarkers={setMarkers} />

      {markers.map((pos, index) => (
        <Marker key={index} position={pos} />
      ))}
    </MapContainer>
  );
};

export default PhilippinesMap;
